import { render, staticRenderFns } from "./dwComponent.vue?vue&type=template&id=3995c7b3&scoped=true"
import script from "./dwComponent.vue?vue&type=script&lang=js"
export * from "./dwComponent.vue?vue&type=script&lang=js"
import style0 from "./dwComponent.vue?vue&type=style&index=0&id=3995c7b3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3995c7b3",
  null
  
)

export default component.exports